import _ from 'lodash';
import {GA_SITENAMES} from './constants';

/**
 * Pushes GA Virtual PageViews to the dataLayer
 * @param   {String}    pageViewPath The path for the GA pageview
 * @return  {Undefined} Returns nothing
 */
export function setVirtualPageView(pageViewPath) {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({
      event: 'analyticsVPV',
      vpvName: pageViewPath,
    });
  }
}

/**
 * Pushes GA tags to the dataLayer
 * @param   {Object}    obj The GA tag infromation for a particular event
 * @return  {Undefined} Returns nothing
 */
export function getGATags(obj) {
  if (_.isObject(obj)) {
    const pushedTracking = _.cloneDeep(obj);

    pushedTracking.event = 'GAEvent';
    if (typeof window !== 'undefined') {
      window.dataLayer.push(pushedTracking);
    }
  }
}

/**
 * Gets the ga event label from the obit
 * @method getObitGAEventLabel
 * @param  {Object}  obit The obituary to get affiliate information from
 * @return {String}  Returns the event label with type, name and id
 */
export function getObitGAEventLabel(obit) {
  let eventLabel = null;
  const {gaSitename, funeralHomeId} = obit || {};

  if (gaSitename) {
    if (gaSitename === 'legacy') {
      eventLabel = 'legacy_obit';
    } else {
      const funeralHomes = ['batesville', GA_SITENAMES.dignityMemorial, GA_SITENAMES.tributes];
      const affiliateType = _.find(funeralHomes, fh => fh === gaSitename)
        ? 'fh'
        : 'np';

      if (affiliateType === 'fh' && funeralHomeId) {
        eventLabel = `${affiliateType}_${gaSitename}_${funeralHomeId}_obit`;
      } else {
        eventLabel = `${affiliateType}_${gaSitename}_obit`;
      }
    }
  }

  return eventLabel;
}

/**
 * A function to be placed in onClick for analytics tracking
 * @method gaClickHandler
 * @param  {String}          eventCategory Google event category
 * @param  {String}          eventAction   Google event action
 * @param  {Object|String}   eventLabel    Information about the event label
 * @return {Function} Returns a function that will run getGATags
 */
export function gaClickHandler(eventCategory, eventAction, eventLabel) {
  return () => {
    getGATags({
      eventCategory,
      eventAction,
      eventLabel: _.isString(eventLabel)
        ? eventLabel
        : getObitGAEventLabel(eventLabel),
    });
  };
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/GAHelpers.js